<template>
  <span>
    <div class="a-container-form justify-content-end u-padding-bottom-12">
      <button class="gui-btn gui-btn--small gui-btn--white-border"
              @click.prevent="onHideAllClick">
        Скрыть все
      </button>
    </div>
    <ul class="list-group list-group-flush">
      <notification-item :event="event"
                         @close="$emit('close')"
                         :key="[event.objectId, event.type, idx].join('-')"
                         v-for="(event, idx) in items">
      </notification-item>
    </ul>
  </span>
</template>

<script>
  import NotificationItem from './NotificationItem'

  export default {
    props: {
      items: {
        type: Array,
        required: true
      }
    },

    components: {
      NotificationItem
    },

    methods: {
      onHideAllClick() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('markReadAllNotifications');
          }
          catch(e) {
            console.error('unable to hide all notifications')
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list-group-item {
    padding: 10px 0px;
    min-height: 50px;
    cursor: pointer;
  }
</style>
